export default __webpack_public_path__ + "static/media/account-icon.e50bb610.svg";